import { product } from "../constants/configMap";
import { getCookie } from "../cookiesUtils";
export function getSourceId(countryCode) {
    return 12;
}
export function getProductId() {
    return product;
}
export function getPromoName() {
    return getCookie("promoName");
}
var hostname = window.location.hostname;
export var isFpGold = true;
export var isStage = RegExp(/(mob.qa-gold.kg)/gi).test(hostname);



// WEBPACK FOOTER //
// ./src/shared/domainUtils.js